export default "__VITE_ASSET__3d3202df__"